export default (num = 0, dec = 2, maxDec) => {
  if (maxDec) {
    return Number(num).toLocaleString(undefined, {
      minimumFractionDigits: dec,
      maximumFractionDigits: maxDec,
    });
  }
  return Number(num).toLocaleString(undefined, { minimumFractionDigits: dec });
};
